<template>
    <section>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">

            <!--Groups list-->
            <el-tab-pane label="Payment Requests" name="first">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true" :model="filters">
                        <el-select v-model="filters.paymentStatus" placeholder="Status" @change="getPaymentRequest()"
                                   clearable>
                            <el-option label="Pending" value="0"></el-option>
                            <el-option label="Confirmed" value="1"></el-option>
                            <el-option label="Canceled" value="2"></el-option>
                            <el-option label="Archived" value="3"></el-option>
                            <el-option label="Rejected" value="4"></el-option>
                        </el-select>
                        <el-form-item>
                            <el-button type="primary" @click="exportExcel('/excel/exportNursePayment','payment.xls')">Export</el-button>
                        </el-form-item>
                        <el-form-item class="pull-right">
                            <el-button type="primary" v-on:click="showAddPayment">Request a payment</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="payments" highlight-current-row v-loading="firstListLoading" style="width: 100%;">
                    <el-table-column prop="paymentNo" label="#">
                    </el-table-column>
                    <el-table-column prop="doctorName" label="Company">
                    </el-table-column>
                    <el-table-column prop="amount" label="Amount">
                        <template slot-scope="scope">
                            {{formatMoney(scope.row.amount,2)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="doctorNote" label="Doctor Note">
                        <template slot-scope="scope" >
                            <div v-html="scope.row.doctorNote"></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="nurseNote" label="Nurse Note">
                        <template slot-scope="scope" >
                            <div v-html="scope.row.nurseNote"></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createDate" label="Request Date">
                    </el-table-column>
                    <el-table-column label="Status">
                        <template slot-scope="scope">
                            <p v-if="scope.row.status===0">
                                <el-tag type="info">Pending</el-tag>
                            </p>
                            <p v-if="scope.row.status===1">
                                <el-tag type="success">Confirmed</el-tag>
                            </p>
                            <p v-if="scope.row.status===2">
                                <el-tag type="danger">Canceled</el-tag>
                            </p>
                            <p v-if="scope.row.status===4">
                                <el-tag type="danger">Rejected</el-tag>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column label="Action">
                        <template slot-scope="scope">
                            <el-button size="small" v-if="scope.row.status===0" type="danger"
                                       @click="editPaymentStatus(scope.row.paymentNo,2)">Cancel
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="changePaymentRequest"
                                   :page-size="pageSize" :total="paymentTotal"
                                   style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>
            <!--open list-->
            <el-tab-pane label="Pending Transactions" name="second">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true" :model="filters">
                        <el-form-item>
                            <el-input v-model="filters.pendingFilter" placeholder="Offer" clearable>
                                <el-button slot="append" icon="el-icon-search"
                                           @click="getPendingTransaction"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="pendingPayments" highlight-current-row v-loading="secondListLoading"
                          style="width: 100%;">
                    <el-table-column prop="offerNo" label="#">
                    </el-table-column>
                    <el-table-column prop="productName" label="Offer">
                    </el-table-column>
                    <el-table-column prop="user" label="Company">
                    </el-table-column>
                    <el-table-column prop="price" label="Price">
                    </el-table-column>
                    <el-table-column prop="quantity" label="Qty">
                    </el-table-column>
                    <el-table-column prop="warehouse" label="Warehouse">
                    </el-table-column>
                    <el-table-column prop="takeDate" label="Offer Create Date">
                    </el-table-column>
                    <el-table-column prop="inboundDate" label="Inbound Date">
                    </el-table-column>
                </el-table>


                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="changePendingRequest"
                                   :page-size="pageSize" :total="pendingTotal"
                                   style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>

            <!--Invitations list-->
            <el-tab-pane label="Transaction History" name="third">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true" :model="filters">
                        <el-form-item>
                            <el-input v-model="filters.historyFilter" placeholder="Search Product Name, Note, Account etc." clearable>
                                <el-button slot="append" icon="el-icon-search"
                                           @click="getTransactionHistory"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="transactions" highlight-current-row v-loading="thirdListLoading" :row-class-name="tableRowClassName"
                          style="width: 100%;">
                    <el-table-column label="Transaction">
                        <template slot-scope="scope">
                            <div v-if="scope.row.type=='transaction'">
                                <p>For {{scope.row.productName}}, {{scope.row.dateTime}}</p>
                                <p class="note">${{scope.row.price}} * {{scope.row.quantity}}.
                                    {{scope.row.warehouse}}</p>
                            </div>
                            <div v-if="scope.row.type=='reported'">
                                <p>Reported for {{scope.row.productName}}, {{scope.row.dateTime}}</p>
                                <p class="note">${{scope.row.price}} * {{scope.row.quantity}}.
                                    {{scope.row.warehouse}}</p>
                            </div>
                            <div v-if="scope.row.type=='adjust'">
                                <p v-if="scope.row.amount>0">Increase Balance, {{scope.row.dateTime}}</p>
                                <p v-if="scope.row.amount<=0">Decrease Balance, {{scope.row.dateTime}}</p>
                                <div class="note" v-html="scope.row.note"></div>
                            </div>
                            <div v-if="scope.row.type=='payment'">
                                <p>Withdraw to {{scope.row.productName}}, {{scope.row.dateTime}}
                                    <span v-if="scope.row.status===0">(waiting for pay)</span>
                                    <span v-else-if="scope.row.status===1">(paid)</span>
                                    <span v-else-if="scope.row.status===2">(canceled)</span>
                                    <span v-else-if="scope.row.status===3">(rollover)</span>
                                </p>
                                <div class="note" v-html="scope.row.note"></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="amount" label="Amount">
                        <template slot-scope="scope">
                            {{formatMoney(scope.row.amount,2)}}
                        </template>
                    </el-table-column>
                    <el-table-column label="Balance" prop="balance">
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="changeTransactionHistory"
                                   :page-size="pageSize"
                                   :total="historyTotal" style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>

            <el-tab-pane label="Balance" name="fourth">
                <!--列表-->
                <el-table stripe :data="balances" highlight-current-row v-loading="fourthListLoading" :row-class-name="tableRowClassName"
                          style="width: 100%;">
                    <el-table-column prop="userName" label="Company">
                    </el-table-column>
                    <el-table-column prop="total" label="Total">
                        <template slot-scope="scope">
                            {{formatMoney(scope.row.total,2)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="pendingAmount" label="Pending">
                        <template slot-scope="scope">
                            {{formatMoney(scope.row.pendingAmount,2)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="requestAmount" label="Request Pay">
                        <template slot-scope="scope">
                            {{formatMoney(scope.row.requestAmount,2)}}
                        </template>
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="changeBalance" :page-size="pageSize"
                                   :total="balanceTotal" style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>
        </el-tabs>

        <!--编辑界面-->
        <el-dialog title="Request a payment" width="80%" :visible.sync="requestVisible" :close-on-click-modal="false">
            <el-form :model="payment" label-width="220px" ref="payment" :rules="requestFormRules">
                <el-form-item label="Total Balance" prop="balance">
                    <el-input-number v-model="payment.balance" :disabled="true"></el-input-number>
                </el-form-item>
                <el-form-item label="Amount" prop="amount">
                    <el-input-number v-model="payment.amount" :min="0" :max="payment.balance"></el-input-number>
                </el-form-item>
                <el-form-item label="Bank Account" prop="bank">
                    <el-select v-model="payment.bank" clearable filterable>
                        <el-option v-for="(bank,index) in banks" :key="index"
                                   :label="bank.category + ' ' +bank.accountNumber+' ('+bank.accountType+')'"
                                   :value="bank.bankNo"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Note" prop="note">
<!--                    <el-input v-model="payment.note" type="textarea" rows="5"></el-input>-->
                    <quill-editor v-model="payment.note" ref="myQuillEditor" :options="editorOption"></quill-editor>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="requestVisible = false">Close</el-button>
                <el-button type="primary" @click.native="requestPayment" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>
        <!--add group界面-->
    </section>
</template>


<script>
    import { quillEditor } from 'vue-quill-editor'
    import util from '../../common/js/util'
    import {getUserBalance} from "../../api/memberService";
    import {
        getPaymentRequest,
        getBalance,
        getTransaction,
        addPaymentRequest,
        getBankList,
        editPaymentStatus,
        getPendingTransaction,
        getTransactionHistory
    } from "../../api/paymentService";
    import ElOption from "element-ui/packages/select/src/option";
    import {defaultPageSize} from "../../globalVar";
    import {postExportExcel} from "../../api/exportService";

    export default {
        components: {ElOption},
        created() {
            this.$on('changeDoctor', (value) => {
                setTimeout(() => {
                    this.getPaymentRequest();
                    this.getPendingTransaction();
                    this.getBalance();
                    this.getTransactionHistory();
                }, 300);
            });
        },
        data() {
            return {
                editorOption: {
                    theme: "snow", // or 'bubble'
                    placeholder: "Note",
                    height:"400px",
                    modules: {
                        toolbar: {
                            container: [
                                ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
                                ["link"] // 链接、图片、视频
                            ]
                        }
                    }
                },
                currentUser: "",
                banks: [],
                currentCompany: "",
                activeName: "first",
                filters: {
                    pendingFilter: "",
                    paymentFilter: "",
                    historyFilter: "",
                    paymentStatus: "",
                    name: ''
                },

                pageSize: defaultPageSize,
                paymentPage: 1,
                paymentTotal: 0,

                pendingPage: 1,
                pendingTotal: 0,

                balancePage: 1,
                balanceTotal: 0,

                historyPage: 1,
                historyTotal: 0,

                firstListLoading: false,
                secondListLoading: false,
                thirdListLoading: false,
                fourthListLoading: false,

                offers: [],
                transactions: [],
                pendingPayments: [],
                payments: [],
                paymentHistory: [],
                balances: [],
                total: 0,
                invitations: [],
                invitationTotalPage: 0,
                invitationPage: 1,
                listLoading: false,
                sels: [],//列表选中列
                requestVisible: false,//编辑界面是否显示
                addGroupVisible: false,
                invitationVisible: false,
                editLoading: false,
                requestFormRules: {
                    amount: [
                        {required: true, message: 'Amount is required.', trigger: 'blur'},
                        {validator: this.validateAmount, trigger: 'blur'}
                    ],
                    bank: [
                        {required: true, message: '', trigger: 'blur'}
                    ]
                },

                addFormVisible: false,//新增界面是否显示
                loading: false,
                //新增界面数据
                payment: {
                    amount: "",
                    bank: "",
                    note: "",
                    balance:0,
                    minPayment:0
                }
            }
        },
        methods: {
            exportExcel(url,fileName){
                let param = {
                    url:url,
                    fileName:fileName,
                    doctorNo:window.sessionStorage.getItem("currentCompany"),
                }
                postExportExcel(param).then(function(){

                })
            },
            formatMoney:function (s, n) {
                n = n > 0 && n <= 20 ? n : 2;
                s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
                var l = s.split(".")[0].split("").reverse();
                let r = s.split(".")[1];
                let t = "";
                if (s < 0) {
                    l = ((Math.abs(s.split(".")[0])) + "").split("").reverse();
                }
                for (let i = 0; i < l.length; i++) {
                    t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
                }
                if (s < 0) {
                    t += "-";
                }
                var result =  t.split("").reverse().join("") + "." + r;
                if(result==null||result==undefined||result.indexOf('NaN')>=0||result.indexOf('Undefined')>=0){
                    result = '0.00';
                }
                return result;
            },
            showAddPayment(){
                let user = JSON.parse(sessionStorage.getItem("user"));
                let param = {
                    doctorNo:window.sessionStorage.getItem("currentCompany"),
                    nurseNo:user.userNo
                }
                getUserBalance(param).then((res)=>{
                    if(res.status===200){
                        this.payment.balance = res.result.balance;
                        this.payment.minPayment = res.result.minPayment;
                        this.requestVisible = true;
                    }
                })
            },
            tableRowClassName({row, rowIndex}) {
                if (row.amount<0||row.total<0) {
                    return 'reported-row';
                } else {
                    return '';
                }
            },
            changePaymentRequest(val) {
                this.paymentPage = val;
                this.getPaymentRequest();
            },
            changePendingRequest(val) {
                this.pendingPage = val;
                this.getPendingTransaction();
            },
            changeBalance(val) {
                this.balancePage = val;
                this.getBalance();
            },
            changeTransactionHistory(val) {
                this.historyPage = val;
                this.getTransactionHistory();
            },
            getTransactionHistory() {
                let param = {
                    current: this.historyPage,
                    size: this.pageSize,
                    doctorNo: window.sessionStorage.getItem("currentCompany"),
                    condition: this.filters.historyFilter,
                }
                this.thirdListLoading = true;
                getTransactionHistory(param).then((data) => {
                    this.thirdListLoading = false;
                    if (data.status === 200) {
                        this.transactions = data.result.records;
                        this.historyTotal = data.result.total;
                    }
                })
            },
            editPaymentStatus(paymentNo, status) {
                this.$confirm("Are you sure?", "Warning", {
                    type: "warning"
                }).then(() => {
                    let param = {
                        paymentNo: paymentNo,
                        status: status
                    };
                    editPaymentStatus(param).then((data) => {
                        if (data.status === 200) {
                            this.$message.success(data.message);
                            this.getPaymentRequest();
                        }
                    })
                }).catch(() => {
                })
            },
            getBankList() {
                getBankList({}).then((data) => {
                    if (data.status === 200) {
                        this.banks = data.result;
                    }
                })
            },
            getPendingTransaction() {
                let param = {
                    current: this.pendingPage,
                    size: this.pageSize,
                    condition: this.filters.pendingFilter,
                    doctorNo: window.sessionStorage.getItem("currentCompany")
                };
                this.secondListLoading = true;
                getPendingTransaction(param).then((data) => {
                    this.secondListLoading = false;
                    if (data.status === 200) {
                        this.pendingPayments = data.result.records;
                        this.pendingTotal = data.result.total;
                    }
                })
            },
            requestPayment() {
                this.$refs.payment.validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        let param = {
                            amount: this.payment.amount,
                            bankNo: this.payment.bank,
                            doctorNo: window.sessionStorage.getItem("currentCompany"),
                            nurseNote: this.payment.note
                        };
                        addPaymentRequest(param).then((data) => {
                            this.loading = false;
                            if (data.status === 200) {
                                this.$message.success(data.message);
                                this.requestVisible = false;
                                this.$refs.payment.resetFields();
                                this.getPaymentRequest();
                                this.getTransactionHistory();
                            }
                        })
                    }
                })
            },
            validateAmount(rule, value, callback) {
                if (value > 0) {
                    if(value<this.payment.minPayment){
                        callback(new Error('Your amount must be greater than $'+this.payment.minPayment+'.'));
                    }else{
                        callback()
                    }
                } else {
                    callback(new Error('Amount is required.'));
                }
            },
            getBalance() {
                let param = {
                    current: this.balancePage,
                    size: this.pageSize,
                    doctorNo: window.sessionStorage.getItem("currentCompany")
                };
                this.fourthListLoading = true;
                getBalance(param).then((data) => {
                    this.fourthListLoading = false;
                    if (data.status === 200) {
                        this.balances = data.result.records;
                        this.balanceTotal = data.result.total;
                    }
                })
            },
            handleClick() {

            },
            getPaymentRequest() {
                let param = {
                    current: this.paymentPage,
                    size: this.pageSize,
                    status: this.filters.paymentStatus,
                    doctorNo: window.sessionStorage.getItem("currentCompany")
                };
                this.firstListLoading = true;
                getPaymentRequest(param).then((data) => {
                    this.firstListLoading = false;
                    if (data.status === 200) {
                        this.payments = data.result.records;
                        this.paymentTotal = data.result.total;
                        //this.paymentHistory = data;
                    }
                })
            }

        },
        mounted() {
            this.getPendingTransaction();
            this.getPaymentRequest();
            this.getBalance();
            this.getBankList();
            this.getTransactionHistory();
        }
    }

</script>
<style>
</style>


// WEBPACK FOOTER //
// payments.vue?bcf81a10